import { inject, Injectable } from '@angular/core';
import { GoogleTagManagerService } from 'angular-google-tag-manager';

@Injectable({
  providedIn: 'root',
})
export class AppService {
  private gtmService = inject(GoogleTagManagerService);

  constructor() {
    this.addGTM();
  }

  private addGTM(): void {
    this.gtmService.addGtmToDom().then((success) => {
      if (success) {
        return;
      }
      console.warn('GTM failed to load — analytics events will not be sent');
    });
  }
}
